import $ from "jquery";

function openBuilding() {
  const buildings = document.querySelectorAll("[data-building-url]");

  buildings.forEach((item) => {
    $(item).on("touchend click", function () {
      const url = this.getAttribute("data-building-url");
      window.open(url, "_self");
    });
  });
}

export { openBuilding };
